import React from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getUserById, getIsUserUpdated, fetchUserById, patchUserById, getIsUserLoading, getError } from '../../reducers/user';
import { fetchGroups, getGroups, getIsGroupLoading } from "../../reducers/group";
import { getCurrentUser } from '../../reducers/login'
import UpdateUserPage from "../../components/RoleBased/UpdateUserPage";
import { Redirect } from "react-router";

const UpdateUserContainer = props => {
    return props.currentUser.id === props.userId || props.currentUser.optional.role === 'admin' ? <UpdateUserPage {...props} /> : <Redirect to="/noAccess" />
}

const mapState = (state, props) => ({
    userId: props.match.params.userId,
    userById: getUserById(state),
    isUserUpdated: getIsUserUpdated(state),
    currentUser: getCurrentUser(state),
    groups: getGroups(state),
    isLoading: getIsUserLoading(state) || getIsGroupLoading(state),
    error: getError(state),
});

const actions = (dispatch, props) => ({
    updateUser: bindActionCreators(patchUserById, dispatch),
    fetchUser: bindActionCreators(fetchUserById, dispatch),
    fetchGroups: bindActionCreators(fetchGroups, dispatch),
});

export default connect(mapState, actions)(UpdateUserContainer);